import React, { useState } from 'react';
import FeaturedBlog from "./FeaturedBlog";
import BlogsAside from "./BlogsAside";
import BlogImage01 from "../../../../assets/image/image-blog-01.webp";
import BlogImage02 from "../../../../assets/image/image-blog-02.webp";
import Button from "../../../form/Button";
import { getBlogList } from '../../../../services/BlogService';
import useFetch from '../../../../hooks/useFetch';
import dayjs from 'dayjs';
import { removeDuplicateFromArray } from '../../../../helpers';

const SectionBlogs = () => {

  // const FeaturedBlogData = {
  //   image: BlogImage01,
  //   title: "10 Effective Study Tips for College Success",
  //   description: "At the V’Peters Family Scholarship, we are committed to transforming lives — One Scholarship at a Time. Explore our initiatives below and see the impact of your contributions in shaping the future of aspiring students. Together, we are building a brighter future—one student at a time.",
  //   date: "August 20, 2024",
  //   time: "6:16 am",
  //   postedBy: "Admin",
  //   link: "/blogs/1",
  // }

  // const BlogsData = {
  //   title: "All Blog",
  //   blogs: [
  //     { _id: 1, image: BlogImage02, title: "Can you provide proof of financial need?", link: "/blogs/1" },
  //     { _id: 2, image: BlogImage01, title: "Can you provide proof of financial need?", link: "/blogs/2" },
  //     { _id: 3, image: BlogImage02, title: "Can you provide proof of financial need?", link: "/blogs/3" },
  //     { _id: 4, image: BlogImage01, title: "Can you provide proof of financial need?", link: "/blogs/4" },
  //     { _id: 5, image: BlogImage02, title: "Can you provide proof of financial need?", link: "/blogs/5" },
  //     { _id: 6, image: BlogImage01, title: "Can you provide proof of financial need?", link: "/blogs/6" },
  //     { _id: 7, image: BlogImage02, title: "Can you provide proof of financial need?", link: "/blogs/7" },
  //     { _id: 8, image: BlogImage01, title: "Can you provide proof of financial need?", link: "/blogs/8" },
  //     { _id: 9, image: BlogImage02, title: "Can you provide proof of financial need?", link: "/blogs/9" },
  //     { _id: 10, image: BlogImage01, title: "Can you provide proof of financial need?", link: "/blogs/10" },
  //   ]
  // }




  return (
    <>
      <section className="relative flex w-full py-16 sm:py-24 bg-white">
        <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
          <div className="grid grid-cols-12 gap-y-10 md:gap-10">
            <div className="col-span-12 lg:col-span-7 flex">
              <FeaturedBlog />
            </div>
            <div className="col-span-12 lg:col-span-5 flex">
              <BlogsAside />
            </div>
          </div>
          <div className="flex items-center justify-center mt-16">
            <Button
              buttonLabel={"View All Blogs"}
              buttonClasses={"!h-12 xl:!h-14 !rounded-full !px-6 xl:!px-10 border border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white min-w-60"}
              buttonLabelClasses={"!text-base xl:!text-xl"}
              buttonHasLink={true}
              buttonLink={"/blogs"}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default SectionBlogs;